<template>
    <!-- 添加数据2 -->

    <a-modal title="新增用户" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>用户名称：</a>
            <a-input v-model:value="pushData.username" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>用户密码：</a>
            <a-input-password v-model:value="pushData.password" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>电话号码：</a>
            <a-input v-model:value="pushData.phoneNumber" maxlength="11" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>部门选择：</a>
            <a-select v-model:value="pushData.deptId" class="push-data">
                <a-select-option v-for="p in depts" :key="p.id" :value="p.id">{{ p.deptName }}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>权限选择：</a>
            <a-select v-model:value="pushData.permissionsId" class="push-data">
                <a-select-option v-for="p in permissions" :key="p.id" :value="p.id">{{ p.permissionName
                    }}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a>电子邮箱：</a>
            <a-input v-model:value="pushData.email" maxlength="30" class="push-data" />
        </div>
        <div class="push-avatar">
            <a style="width: 100%;">上传头像：</a>
            <a-upload name="file" list-type="picture-card" class="avatar-uploader" maxCount=1
                :show-upload-list="false" 
                :headers="getUploadHeaders()"
                action="http://127.0.0.1:9090/simpleAdmin/common/uploadAvatar" 
                @success="avatarSuccess"
                @change="handleChange">

                <img v-if="avatarPreviewUrl" :src="avatarPreviewUrl"
                    alt="avatar" style=" width: 100%;height: 100%;" />
                <div v-else>
                    <loading-outlined v-if="loadingAvatar"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">Upload</div>
                </div>
            </a-upload>
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveUsers, listDepts, listPermissions, pushAvatar, readFileBlob } from '@/api/service';
import { generateSignHeaders } from '@/utils/sign';
import { message } from 'ant-design-vue';
import { ref, onBeforeUnmount } from 'vue';
export default {
    name: 'addComponent',
    methods: {
        getUploadHeaders() {
            return {
                'token': localStorage.getItem('token'),
                'tenantId': localStorage.getItem('tenantId'),
                ...generateSignHeaders()
            };
        }
    },
    setup() {
        const loading = ref(false);//添加提交时的加载
        const loadingAvatar = ref(false);//头像加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        const depts = ref([]);//父级菜单
        const permissions = ref([]);//父级菜单
        const imageUrl = ref('');//头像
        const avatarPreviewUrl = ref('');//头像预览地址（blob objectURL）

        //加载头像预览：走统一请求层以携带签名头，避免浏览器直链请求被后端拒绝
        const loadAvatarPreview = async () => {
            if (!imageUrl.value) {
                return;
            }
            try {
                const blob = await readFileBlob(imageUrl.value);
                if (avatarPreviewUrl.value) {
                    window.URL.revokeObjectURL(avatarPreviewUrl.value);
                }
                avatarPreviewUrl.value = window.URL.createObjectURL(blob);
            } catch (e) {
                console.error('头像预览加载失败', e);
            }
        };

        onBeforeUnmount(() => {
            if (avatarPreviewUrl.value) {
                window.URL.revokeObjectURL(avatarPreviewUrl.value);
            }
        });
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
        //查询部门列表
        const listDept = async () => {
            const response = await listDepts();
            if (response.code === 200) {
                depts.value = response.data;
            }
        }
        //查询权限列表
        const listpermissions = async () => {
            const response = await listPermissions();
            if (response.code === 200) {
                permissions.value = response.data;
            }
        }

        /**
         * 处理文件上传状态改变
         *
         * @param info 文件上传状态信息
         * @returns 无返回值
         */
        const handleChange = info => {
            if (info.file.status === 'uploading') {
                loadingAvatar.value = true;
            }
            if (info.file.status === 'removed') {
                message.info('删除成功');
            }
            if (info.file.status === 'error') {
                loadingAvatar.value = false;
                message.error('上传失败');
                return false;
            }
            if (info.file.status === 'done') {
                message.success('上传成功');
            } 
        };

        /**
         * 头像上传成功回调函数
         *
         */
        const avatarSuccess = (response) => {
            imageUrl.value = response.data;
            loadAvatarPreview();
        }

        //提交数据
        const handleOk = async () => {
            pushData.value.avatar = imageUrl.value;
            loading.value = true;
            const response = await saveUsers(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                loading.value = true;
                pushData.value = {};
                imageUrl.value = '';
                if (avatarPreviewUrl.value) {
                    window.URL.revokeObjectURL(avatarPreviewUrl.value);
                    avatarPreviewUrl.value = '';
                }
                loading.value = true;
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                loading.value = true;
                open.value = false;
                return false;
            }
        }
        listDept();
        listpermissions();
        return {
            loading,
            loadingAvatar,
            open,
            pushData,
            listDept,
            listpermissions,
            pushAvatar,
            permissions,
            imageUrl,
            avatarPreviewUrl,
            handleChange,
            avatarSuccess,
            depts,
            parent,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}
.push-avatar{
    margin-top: 20px;
    display: inline-flex;
}

.modals {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 400px;
}

.push-data {
    width: 80%;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}
</style>